import axios from 'axios';
import store from './store';
import { whenIdle } from './activity';

// Notices when a signed-in tab has lost its session (cookie expired, signed out in another tab, a support session ran
// its time...). The API answers 401 to any request that needs a session it doesn't have (apiroutes.ts checkIfUser),
// and a tab left alone asks /api/sessioncheck, so it finds out before someone starts typing into it.
// It reloads the page rather than going straight to the login page: App.vue's load restores the session from the
// saved login token if it can (iOS drops the cookie), and otherwise sends them to login with a redirect back here.
// App.vue calls startSessionGuard() once.

const RELOADED_KEY = 'session_lost_reload_at';
const RELOAD_LOOP_MS = 15000; // lost again this soon after reloading: go to the login page instead of reloading again
let handling = false;

function sessionLost() {
    if(handling) {
        return;
    }
    handling = true;
    let reloadedAt = 0;
    try {
        reloadedAt = Number(sessionStorage.getItem(RELOADED_KEY)) || 0;
    } catch(e) {
        // storage blocked: the reload below is still fine
    }
    if(Date.now() - reloadedAt < RELOAD_LOOP_MS) {
        window.location.href = '/login?redirect=' + encodeURIComponent(window.location.pathname);
        return;
    }
    try {
        sessionStorage.setItem(RELOADED_KEY, '' + Date.now());
    } catch(e) {
        // as above
    }
    window.location.reload();
}

export function startSessionGuard() {
    axios.interceptors.response.use(response => response, error => {
        // Only our own API's 401s, and only once this tab is signed in (the login pages handle their own errors)
        const url = String(error?.config?.url || '');
        if(error?.response?.status == 401 && store.state.signedIn && url.startsWith(store.state.apiUrl + '/api/')) {
            sessionLost();
            // Left pending: the page is about to reload, so the caller shouldn't also show an error
            return new Promise(() => null);
        }
        return Promise.reject(error);
    });

    whenIdle(15 * 60 * 1000, () => {
        if(store.state.signedIn) {
            axios.get(`${store.state.apiUrl}/api/sessioncheck`).catch(() => null);
        }
    });
}
